(() => {
  const collapseFaq = (root = document) => {
    root
      .querySelectorAll('section[id*="faq" i] details, .faq details, [class*="faq" i] details, [data-faq] details')
      .forEach((item) => item.removeAttribute('open'));
  };

  const initialize = () => collapseFaq(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => collapseFaq(event.target));
})();
